import { Sparkles, Heart, Check } from 'lucide-react';
import type { DayStats } from '../../lib/weekStats';
import { DAY_LABELS } from '../../types/exercise';

interface DayProgressRowProps {
  stats: DayStats;
  isToday: boolean;
}

export function DayProgressRow({ stats, isToday }: DayProgressRowProps): JSX.Element {
  const isFullTraining =
    stats.plan.kind === 'training' &&
    stats.totalExercises > 0 &&
    stats.completedExercises === stats.totalExercises;

  return (
    <li
      className={`flex items-center gap-3 rounded-xl border bg-white p-4 ${
        isToday ? 'border-emerald-500' : 'border-zinc-200'
      }`}
    >
      <span className="flex w-12 shrink-0 flex-col items-center">
        <span className="text-xs font-semibold uppercase text-zinc-500">
          {DAY_LABELS[stats.dayOfWeek].slice(0, 2)}
        </span>
        <span className="text-base font-semibold tabular-nums text-zinc-900">
          {stats.date.getDate()}.
        </span>
      </span>

      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-base font-semibold text-zinc-900">{stats.plan.title}</span>
        <span className="truncate text-sm text-zinc-600">
          {summary(stats)}
        </span>
      </span>

      <span className="shrink-0">{badge(stats, isFullTraining)}</span>
    </li>
  );
}

function summary(s: DayStats): string {
  if (s.plan.kind === 'pilates') return 'Geplanter Pilates-Kurs';
  if (s.plan.kind === 'recovery') return 'Stretching & optionaler Spaziergang';
  return `${s.totalSetsDone} von ${s.totalSets} Sets`;
}

function badge(s: DayStats, isFullTraining: boolean): JSX.Element {
  if (s.plan.kind === 'pilates') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700">
        <Sparkles aria-hidden="true" className="size-3.5" />
        Pilates
      </span>
    );
  }
  if (s.plan.kind === 'recovery') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">
        <Heart aria-hidden="true" className="size-3.5" />
        Recovery
      </span>
    );
  }
  if (isFullTraining) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500 px-2.5 py-1 text-xs font-semibold text-white">
        <Check aria-hidden="true" className="size-3.5" />
        Fertig
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-full border border-zinc-200 bg-white px-2.5 py-1 text-xs font-semibold tabular-nums text-zinc-700">
      {s.completedExercises}/{s.totalExercises}
    </span>
  );
}
